/*
Guru Prasad 12/05/2022 2700430604 Fixed Sidebar Alignments for toggle
Prakash Gummala 12/06/2022 2700430604 Fixed Logo Alignments.
Prakash Gummala 12/09/2022 2700430604 Fixed sideMenu and Header Responsiveness.
Sohel 05/19/2023 2700430604 Fixed sideMenu Closed Icon Issue.
*/

import React, { useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LayoutContext from '../../../@coremat/CmtLayouts/Vertical/LayoutContext/LayoutContext';
import Logo1 from '../../../assets/images/logo1.jpg';
import { useHistory, useLocation } from 'react-router';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ThemeContext } from '../../../../src/themes/ThemeProvider';
import CloseIcon from '@material-ui/icons/Close';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '10px 0px 10px 5px',
    background: '#ebebeb',
    height: '80px',
    // boxShadow: "11px 11px 11px 25px",
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'Space-between',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      height: '84px',
    },
  },
  avatar: {
    height: '40px',
    width: '40px',
    zIndex: '15',
    // ".Cmt-miniLayout .Cmt-sidebar-content:hover &": {
    //   height: 0,
    //   paddingTop: 0,
    //   opacity: 0,
    //   display: "none",
    // },
  },
  imgAvatar: {
    height: '40px',
    width: '40px',
  },
  userInfo: {
    height: 65,
    opacity: 1,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 10px',
    // ".Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &": {
    //   height: 0,
    //   paddingTop: 0,
    //   opacity: 0,
    //   border: "none",
    // },
  },
  userTitle: {
    marginBottom: 5,
    fontSize: 17,
  },
  userSubTitle: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: 0.25,
  },
  rightIcon: {
    color: 'black',
    position: 'absolute',
    top: '25px',
    right: '-12px',
    border: '1px solid #ebebeb',
    borderRadius: '50%',
    backgroundColor: '#ebebeb',
    cursor: 'pointer',
    fontSize: '30px',
  },
  toggleIconMD: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
}));

const SidebarHeader = () => {
  const classes = useStyles();
  const { isOpen, setOpen } = useContext(LayoutContext);
  const history = useHistory();
  const location = useLocation();
  const handleAccountDetails = () => {
    location?.state?.batchName
      ? sessionStorage.setItem('batchName', location?.state?.batchName)
      : sessionStorage.removeItem('batchName');
    history.push({
      pathname: `/account-summary`,
      state: {
        accountNumber: location?.state?.accountNumber ? location?.state?.accountNumber : '',
        batchName: location?.state?.batchName ? location?.state?.batchName : '',
        accountData: location?.state?.accountData ? location.state.accountData : [],
      },
    });
  };
  const { sideNavSection, toggleSideNavSection, showWidgetSection, setShowWidgetSection } =
    useContext(ThemeContext);
  return (
    <Box className={classes.root}>
      {sideNavSection && !showWidgetSection ? (
        ''
      ) : (
        <img
          className={`${classes.avatar}  ${classes.imgAvatar} logo-close`}
          src={Logo1}
          alt="User Avatar"
        />
      )}

      <Box className={`${classes.userInfo} userinfo`}>
        <Box
          className={`${sideNavSection && !showWidgetSection ? 'pointer' : 'header-image'} `}
          display="flex"
          justifyContent="space-between"
          // alignItems="flex-end"
        >
          <div onClick={() => handleAccountDetails()} role="button" tabIndex={0}>
            <img className={`${classes.imgAvatar} logo-open`} src={Logo1} alt="User Avatar" />
          </div>
          <Typography
            onClick={() => handleAccountDetails()}
            className={classes.userTitle}
            component="h3"
            variant="h6"
          >
            PDS P4
          </Typography>
        </Box>
        <Box className="sidenav-closeicon">
          <CloseIcon
            onClick={() => {
              setOpen(!isOpen);
            }}
          />
        </Box>
      </Box>
      <Box className={classes.toggleIconMD}>
        <ChevronRightIcon
          onClick={() => {
            toggleSideNavSection(true);
            setShowWidgetSection(false);
          }}
          className={`${sideNavSection && !showWidgetSection ? 'rightIcon-open' : 'rightIcon'}`}
        />
      </Box>
    </Box>
  );
};

export default SidebarHeader;
